import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=51b227f4&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b227f4')) {
      api.createRecord('51b227f4', component.options)
    } else {
      api.reload('51b227f4', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=51b227f4&", function () {
      api.rerender('51b227f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Search.vue"
export default component.exports